var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"body-1"},[_vm._v(" "+_vm._s(_vm.$t('Tracking').toUpperCase())+": ")]),_c('v-card-text',{staticClass:"text--primary"},_vm._l((_vm.data.filter(item=>!!item[0].actualEndDateTime)),function(stage){return _c('track-and-trace-row',{key:stage.id,attrs:{"stage":stage}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }